import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { FaImages, FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";
import { useDropzone } from "react-dropzone";
import GalleryModal from "./GalleryModal";
import Pagination from '../../components/Pagination';


function Gallery() {

  const [gallery, setGallery] = useState([]);
  const [addGallery, setAddGallery] = useState(null);
  const [addItem, setAddItem] = useState(null);
  const [editId, setEditId] = useState(null);
  const [files, setFiles] = useState([]);
  const [page, setPage] = useState(1);
  const [pageTeam, setPageTeam] = useState(1);
  const [total, setTotal] = useState(1);
  
  const [formDataGallery, setFormDataGallery] = useState({ title:'', category:'', description:'', thumb:''});
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGalleryId, setSelectedGalleryId] = useState(null);

  const openModal = (id) => {
    setSelectedGalleryId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedGalleryId(null);
  };

  const onDrop = useCallback((acceptedFiles) => {
    const mappedFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );

    setFiles((prev) => [...prev, ...mappedFiles]);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
      "video/*": [],
    },
    multiple: true,
  });

  const removeFile = (fileName) => {
    setFiles((prev) => prev.filter((file) => file.name !== fileName));
  };

  const handleAdd = (event) => {
    setAddGallery(event);
    setFormDataGallery({ title:event.title, category:event.category, description:event.description, thumb:event.thumb  });
  };

  const fetchGallery = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/gallery?page=${page}&limit=999`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];
      setTotal(note.total_pages);

      setGallery(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchGallery();
  }, []);

  const handleEditClick = (item) => {
    setEditId(item.id);

    setFormDataGallery({
      title: item.title,
      description: item.description,
      category: item.category,
      thumb: null
    });

    setAddGallery(true); // buka modal
  };
  

  const handleInsert = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formDataGallery.title);
      formData.append("category", formDataGallery.category);
      formData.append("description", formDataGallery.description);
      formData.append("thumb", formDataGallery.thumb);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/gallery/insert`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {

        // Reset form
        setFormDataGallery({
          image: "",
        });

        setAddGallery(null);
        await fetchGallery();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Galeri berhasil ditambahkan!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal menyimpan data");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Galeri ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/gallery/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Gallery berhasil dihapus.', 'success');
            fetchGallery();
          });
      }
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formDataGallery.title);
      formData.append("description", formDataGallery.description);
      formData.append("category", formDataGallery.category);

      if (formDataGallery.thumb) {
        formData.append("thumb", formDataGallery.thumb);
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/gallery/${editId}`,
        {
          method: "POST", 
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {

        await fetchGallery(); // refresh data
        
        setAddGallery(null);
        await fetchGallery();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Galeri berhasil diupdate!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal update");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 pt-40 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-600  to-[#3E3274] bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-red-600  to-[#3E3274] mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-white"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                Galeri
              </div>
              <div className='flex flex-row p-4'>
                <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-gray-400">
                  <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-red-600  to-[#3E3274] text-transparent">
                    <tr>
                      <th class="p-4 font-medium text-white text-center">Title</th>
                      <th class="p-4 font-medium text-white text-center">Category</th>
                      <th class="p-4 font-medium text-white text-center">Description</th>
                      <th class="p-4 font-medium text-white text-center">Thumbnail</th>
                      <th class="p-4 font-medium text-white text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    {Array.isArray(gallery) && gallery.map((a, idx) => (
                      <>
                        <tr class="hover:bg-gray-500">
                          <td class="p-4 text-white text-center">
                            {a.title}
                          </td>
                          <td class="p-4 text-white text-center">
                            {
                              a.category === "anniv"
                                ? "Anniversary Kenzie Komunika"
                                : a.category === "liburan"
                                ? "Kenzie Komunika Liburan"
                                : a.category === "tahunan"
                                ? "Acara Tahunan Kenzie Komunika"
                                : a.category === "berbagi"
                                ? "Kenzie Komunika Berbagi"
                                : a.category
                            }
                          </td>
                          <td class="p-4 text-white text-center">
                            {a.description}
                          </td>
                          <td class="p-4 text-white text-center">
                            <img className='max-h-64' src={`${process.env.REACT_APP_BASE_URL}uploads/images/${a.thumb}`} />
                          </td>
                          <td class="p-4 text-white text-center">
                            <div className='flex flex-row gap-4 items-center justify-center'>
                              <FaPencil onClick={() => handleEditClick(a)} className='cursor-pointer'></FaPencil> 
                              <FaTrash onClick={() => handleDelete(a.id)} className='cursor-pointer'></FaTrash>
                              <FaImages onClick={() => openModal(a.id)} className='cursor-pointer'></FaImages>
                            </div>
                          </td>
                        </tr>
                      </>
                      ))
                    }
                  </tbody>
                </table>
              </div>
                <Pagination
                  current={page}
                  total={total}
                  onPageChange={setPage}
                />
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={handleAdd} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Tambah</button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      {addGallery && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          onClick={() => {
            setAddGallery(null);
            setEditId(null);
          }}
        >
          <div
            className="bg-white text-black p-6 rounded-2xl w-full max-w-md relative shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
              onClick={() => {
                setAddGallery(null);
                setEditId(null);
              }}
            >
              <X size={20} />
            </button>

            {/* Title */}
            <h3 className="text-xl font-bold mb-6 text-center">
              {editId
                ? "Edit Galeri"
                : "Tambah Galeri "}
            </h3>

            {/* Form */}
            <form
              onSubmit={editId ? handleUpdate : handleInsert}
              className="space-y-4"
            >
              
              {/* Icon Upload */}
              <div>
                <label className="block font-medium mb-1">Title</label>
                <input
                  type="text"
                  name='title'
                  value={formDataGallery.title}
                  onChange={(e) =>
                    setFormDataGallery({
                      ...formDataGallery,
                      title: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>

              <div>
                <label className="block font-medium mb-1">Category</label>
                <select
                  name="category"
                  value={formDataGallery.category}
                  onChange={(e) =>
                    setFormDataGallery({
                      ...formDataGallery,
                      category: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                >
                  <option value="">-- Pilih Category --</option>
                  <option value="anniv">Anniversary Kenzie Komunika</option>
                  <option value="liburan">Kenzie Komunika Liburan</option>
                  <option value="tahunan">Acara Tahunan Kenzie Komunika</option>
                  <option value="berbagi">Kenzie Komunika Berbagi</option>
                </select>
              </div>

              <div>
                <label className="block font-medium mb-1">Description</label>
                <textarea
                  rows="3"
                  value={formDataGallery.description}
                  onChange={(e) =>
                    setFormDataGallery({
                      ...formDataGallery,
                      description: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>

              <div>
                <label className="block font-medium mb-1">Thumbnail</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setFormDataGallery({
                      ...formDataGallery,
                      thumb: e.target.files[0],
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg"
                />
                
                <span className='text-sm text-red-600'><i>*rekomendasi file type: .png, .jpg, .jpeg</i></span>

                {/* Preview Image */}
                {formDataGallery.thumb && (
                  <img
                    src={URL.createObjectURL(formDataGallery.thumb)}
                    alt="preview"
                    className="mt-3 h-20 object-contain rounded-lg border"
                  />
                )}
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition"
                  onClick={() => {
                    setAddGallery(null);
                    setEditId(null);
                  }}
                >
                  Batal
                </button>

                <button
                  type="submit"
                  className="px-6 py-2 rounded-full bg-gradient-to-r from-blue-600 to-red-600 text-white hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  {editId ? "Update" : "Simpan"}
                </button>
              </div>
            </form>
          </div>
          
        </div>
      )}
      <GalleryModal
        idGallery={selectedGalleryId}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </div>
  );
}

export default Gallery;
 